import { useRef } from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";
import { FloatingArrow, arrow, autoUpdate, offset, useFloating } from "@floating-ui/react";

import { SparklesSolidV6, XmarkSolidV6 } from "@shared/v2/Icomoon";

const AIRecordingTip = ({ anchorEl, onDismiss }) => {
  const arrowRef = useRef(null);
  const tooltipPortal = document.getElementById("tooltip-portal-v2") || document.body;
  const { floatingStyles, refs, context } = useFloating({
    placement: "top-end",
    open: true,
    elements: { reference: anchorEl },
    middleware: [offset(16), arrow({ element: arrowRef })],
    whileElementsMounted: autoUpdate,
  });

  return createPortal(
    <div ref={refs.setFloating} style={floatingStyles} className="tw-z-3000 tw-text-12d">
      <div className="tw-py-[8px] tw-px-[16px] tw-text-[#572BAD] tw-font-semibold tw-bg-[#F9F7FD] tw-rounded-[4px] tw-flex tw-items-center tw-gap-[16px] tw-whitespace-nowrap tw-border-[#D8C8FA] tw-border-solid tw-border-[1px]">
        <div className="tw-flex tw-items-center tw-gap-[8px]">
          <SparklesSolidV6 />
          <span>Start recording to take AI notes</span>
        </div>
        <button
          type="button"
          aria-label="Dismiss"
          className="tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer tw-flex tw-items-center"
          onClick={onDismiss}
        >
          <XmarkSolidV6 />
        </button>
      </div>
      <FloatingArrow
        ref={arrowRef}
        className="tw-mt-[-1px]"
        context={context}
        fill="#F9F7FD"
        stroke="#D8C8FA"
        strokeWidth={1}
        height={12}
      />
    </div>,
    tooltipPortal,
  );
};

AIRecordingTip.propTypes = {
  anchorEl: PropTypes.instanceOf(Element),
  onDismiss: PropTypes.func.isRequired,
};

AIRecordingTip.defaultProps = {
  anchorEl: null,
};

export default AIRecordingTip;
